import {Attachment} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'
import {useState, useEffect, useMemo} from 'react'

import {QueryKeyName, getAttachmentFiles} from '../../common/backend'

export const useFileHref = (file?: File): string | undefined => {
  const [href, setHref] = useState<string>()

  useEffect(() => {
    if (file) {
      const href = URL.createObjectURL(file)
      setHref(href)
      return () => URL.revokeObjectURL(href)
    }
  }, [file])

  return href
}

interface AttachmentHrefs {
  fileHref?: string
  previewFileHref?: string
}

export const useAttachmentFiles = (attachment: Attachment): AttachmentHrefs => {
  const isBlobUrl = attachment.url?.startsWith('blob:')

  const {data} = useQuery({
    queryKey: [QueryKeyName.GetAttachmentFiles, attachment.id],
    queryFn: async () => {
      return await getAttachmentFiles(attachment)
    },
    enabled: !isBlobUrl
  })

  const fileHref = useFileHref(data?.file)
  const previewHref = useFileHref(data?.previewFile)

  return useMemo(
    () =>
      isBlobUrl
        ? {fileHref: attachment.url, previewFileHref: attachment.url}
        : {fileHref, previewFileHref: previewHref},
    [isBlobUrl, attachment.url, fileHref, previewHref]
  )
}
